import { createTheme } from '@material-ui/core/styles';

/**
 * Material-UI Theme Configuration
 *
 * @see: https://material-ui.com/customization/theming/
 */

/**
 * hex values from designs:
 *
 * primary:           #ea7134  (orange)         rgb(234, 113, 52)
 * secondary action:  #1e5180  (dark blue)      rgb(30, 81, 128)
 * tertiary action:   #6d7588  (blue-grey)      rgb(109, 117, 136)
 * highlight:         #00a0d1  (brighter blue)  rgb(0, 160, 209)
 * success:           #00855b  (green)          rgb(0, 133, 91)
 * error:             #eb002b  (red)            rgb(235, 0, 43)
 *
 * grey 5:  #606060 (darker to lighter)
 * grey 4:  #cecece
 * gray 3:  #e6e6e6
 * gray 2:  #f3f3f3
 * gray 1:  #f8f8f8
 *
 * black:  #000700
 * white:  #ffffff
 *
 * light text (white): 242	242	243
 * dark text (black): 28	33	28
 */

// default MUI breakpoints
// xs: 0
// sm: 600
// md: 960
// lg: 1280
// xl: 1920

const theme = createTheme({
  palette: {
    background: {
      default: '#ffffff'
    },
    common: {
      black: '#000700'
    },
    error: {
      main: '#eb002b'
    },
    highlight: {
      main: '#00a0d1'
    },
    info: {
      main: '#00a0d1'
    },
    primary: {
      main: '#ea7134'
    },
    secondary: {
      main: '#1e5180'
    },
    tertiary: {
      main: '#6d7588'
    },
    text: {
      disabled: '#cecece',
      hint: '#cecece',
      primary: '#000700',
      secondary: '#606060'
    },
    success: {
      main: '#00855b'
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true // disable ripple effect globally
    }
  },
  shape: {
    borderRadius: 0
  },
  typography: {
    fontFamily: 'Open Sans, Arial, Helvetica, sans-serif',

    h1: {
      fontFamily: 'Tahoma, Geneva, sans-serif',
      fontWeight: 'normal',
      fontSize: 20,
      lineHeight: 'normal',
      letterSpacing: '3.28px',
      textTransform: 'uppercase'
    },
    h2: {
      fontFamily: 'Open Sans, Arial, Helvetica, sans-serif',
      fontWeight: 600, // open sans semi-bold
      fontSize: 20,
      lineHeight: 'normal',
      letterSpacing: '0.03px'
    },
    h3: {
      fontFamily: 'Open Sans, Arial, Helvetica, sans-serif',
      fontWeight: 700, // open sans bold
      fontSize: 18,
      lineHeight: 'normal',
      letterSpacing: '0.03px'
    },
    body1: {
      fontFamily: 'Open Sans, Arial, Helvetica, sans-serif',
      fontWeight: 400, // open sans regular (normal)
      fontSize: 16,
      lineHeight: 'normal',
      letterSpacing: '0.07px'
    },
    button: {
      fontFamily: 'Open Sans, Arial, Helvetica, sans-serif',
      fontWeight: 700, // open sans bold
      fontSize: 14,
      letterSpacing: '0.4px'
    }
  }
});

export default theme;
